import React, { Component } from 'react';
import update from 'immutability-helper'; 
import PreEmpFilters from './PreEmpFilters'
import RescheduledAppointmentDrawer from './RescheduledAppointmentDrawer';
import { message, Popover, Drawer, Tooltip} from 'antd';
import _ from 'lodash'
import { SearchBar, Tabbar } from '../tailwind/molecules';
import AddSingle from './AddSingle';
import CustomDrawer from '../common/organisms/Drawer';
import { Table as AptTable, Pagination  } from '../common/molecules';
import { PRE_EMP_CHECKUPS as HEADERS } from '../../constants/tableHeaders';
import { email_pre, call_icon, download, info_icon, schedule_call, location, created_by,
          doj_calendar, single_add_icon, bulk_add_icon, dob_icon, employee_name,
          green_tick_mark, cross_mark, greenTickThick } from '../../assets/images';
import { Heading, Spinner, SpinnerLinear } from '../common/atoms';
import { employeeDataApi } from '../../services';
import { handleAppError } from '../handlers';
import DropdownTable from '../molecules/DropdownTable';
import EmployeeDetailsCard from './EmployeeDetailsCard';
import VerticalProgressBar from '../common/molecules/VerticalProgressBar';
import { AddAddressModal, ChooseAddressModal, ConfirmModal, PreEmpBookAppointmentModal, PreEmpChooseProviderModal } from '../modals';
import { successOrFailureToaster } from '../common/atoms/messages';
import moment from 'moment';
import DownloadCircularProgressModel from '../modals/DownloadCircularProgressModel';
import { SALES_ROLE } from '../../constants/overview';
import { CustomAppointmentDrawer } from '../common/organisms';
import AppointmentBookedModal from '../modals/AppointmentBookedModal';

const tabbarList = {
  list: ['All', 'Ready to book', 'Attempting to book', 'Scheduled', 'HR intervention required', 'Completed', 'Rejected'],
  ids:  ['all', 'ready_to_book', 'atmpt_to_book', 'scheduled','hr_intervention', 'completed', 'rejected']
};
class PreEmpCheckup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 0,
            companyId: sessionStorage.getItem('company_id'),
            current: 0,
            currentTab: 'all',
            curpage: 0,
            current_page: 1,
            tab_key: 0,
            tab_status: '',
            isLoading: false,
            data: [],
            sponsorId : '',
            visible: false,
            providers: [],
            showCsvLoader: false,
            filters: {
              appointment_status: [],
              doctor_status: [],
              reports_digitized: false,
              company_staff: []
            },
            selected_filters: { 
              selected_appointment_status: [],
              selected_doctor_status: [],
              selected_reports_digitized: false,
              selected_company_staff: []
            },
            show_filters: false,
            filtered: false,
            search_text: "",
            showAppointmentModal: false,
            showEmployeeDetailModal: false,
            employeeDetails: { header: '', data: '' },
            showApproveRequestModal: false,
            showRejectRequestModal: false,
            total: 0,
            showProvider: false,
            appointmentData: {},
            role: sessionStorage.getItem('role'),
            showAddPreEmployeeModal: false,
            showBulkPreEmployeeModal: false,
            showRescheduledAptModal: false,
            showDownloadModel: false,
            csvDownloadState: false,
            progressValue: 0,
            size: 'large',
            business_units: [],
            total_records: {
              all: 0,
              ready_to_book: 0,
              atmpt_to_book: 0,
              scheduled: 0,
              hr_intervention: 0,
              completed: 0,
              rejected: 0,
            },
            viewMoreFlag: false,
            popTable: [],
            buttonTag: '',
            intervalId: null,
            abortId: null,
            progressId: null,
            line1: null,
            showChooseAddressModal: false,
            showAddAddressModal: false,
            newAddress: null,
            showChooseProviderModal: false,
            isNewAddress: false,
            selectedDate: null,
            selectedTime: null,
            uniqueID: null,
            selectedProvider: null
        };
      }

    returnName = (data, tab_header) => {
          return( 
            <div>
                <div className='flex flex-row'>
                  <div className='font-semibold leading-4 cursor-pointer' onClick={() => this.employeeCard(data, tab_header)} style={{color: '#0951E1'}}>{data.name}</div>
                  <Popover placement='right' fitToScreen={true} className='cursor-pointer rounded-md' content={this.renderEmpProfile(data)} title="">
                    <img className='ml-1' src={info_icon} style={{width: '14px'}} alt='info' />
                  </Popover>
                </div>
              <div className='flex flex-row mt-1'>
                <img src={call_icon} style={{width: '16px'}} alt='img' />
                <div className='font-normal leading-4 ml-1.5'>{data.mobile_number}</div>
              </div>
            </div>
           )
        }

    returnEmail = (data) => {
          return(<span>
              <div className='font-semibold leading-4'>{data?.created_by?.name}</div>
              <div className='flex flex-row'>
                <img src={email_pre} alt='email' style={{width: '18px'}} />
                <div className='ml-1'>{data?.created_by?.email}</div>
              </div>
              {/* { data?.upload_date &&
              <div className='flex flex-row'>
                <img src={doj_calendar} alt='cal' style={{width: '16px'}} />
                <div className='text-xs ml-1.5'>{data.upload_date}</div>
              </div>} */}
          </span>)
        }

    appointmentDateTime = (data) => {
          let dateAppt = 'Not available'
          this.formatAppDate = (val) => {
            if(val){
              return(
                val.map(element => (
                  <div>{element}</div>
                ))
              )
            }
          }
          return(
              <div className='item-center'>
                  <span className='flex flex-row items-center ml-1 pl-2'>
                    <div>
                      { data.appointment_date ? this.formatAppDate(data.appointment_date?.split('|')) : 'Not available'}
                    </div>
                    <Popover placement='right' className='cursor-pointer' content={this.renderApptStatus(data)}>
                      <img className='ml-1.5' src={info_icon} style={{width: '14px'}} alt='info' />
                    </Popover>
                  </span>
              </div>
          )
        }

    pageHandler = (total) => {
          return(<Pagination
                    loading={this.state.isLoading}
                    marginTop='mt-3.5'
                    totalpages={total/10}
                    totalresults={total}
                    curpage={this.state.curpage}
                    handler={this.paginateData}
                />)
          }
    
    appointmentTimeline = (data) => {
            let apptRequestTimelines = data?.appointment_request_timelines
            let apptTimelines = [...apptRequestTimelines]
            apptTimelines = apptTimelines.sort((a,b) => moment(b.created_at, "DD MMM YYYY | HH:mm A") - moment(a.created_at, "DD MMM YYYY | HH:mm A"))
            let apptTimelinesKeys = Object.keys(apptTimelines)
            if(apptTimelinesKeys.length !== 0){
              return(
                apptTimelinesKeys.map((key, index) => {
                  if(apptTimelines[key]?.apt_status?.status === 'Awaiting reports') return
                  
                  let backgroundColor = apptTimelines[key]?.apt_status?.background_color
                  let textColor = apptTimelines[key]?.apt_status?.status === 'HR Intervention' ? 'text-black' : 'text-white'
                  return(
                    <li>
                      <div className='relative w-64 pb-8' style={{left: '52px'}}>
                        <div className='text-xs mb-2 font-semibold uppercase tracking-wide' style={{color: '#8895AF'}}>{apptTimelines[key]?.created_at}</div>
                        <div className='mb-3'>
                          <span className={`text-base font-semibold rounded-3xl px-4 py-2 ${textColor}`} style={{backgroundColor: backgroundColor}}>
                            {apptTimelines[key]?.apt_status?.status}
                          </span>
                        </div>
                        {/* <div className='text-xs font-normal mb-2'>Status changed Contacted to Scheduled</div> */}
                        { apptTimelines[key]?.comments && <div className='font-normal text-sm leading-3'>Comment: <span className='font-semibold ' >{apptTimelines[key]?.comments}</span></div>}
                      </div>
                    </li>
                  )
                })
              )
            }else{
              return(
                <div className='flex h-full justify-center m-12 text-center items-center font-semibold text-xs leading-4 tracking-wide' style={{color: '#A4B0CC'}}>
                  NO DATA AVAILABLE
                </div>
              )
            }
          }
  
    appointmentTimelineFormat(data){
      return(
        <div style={{width: '332px', maxHeight: '532px'}}>
          <div className='overflow-y-scroll -m-2 -mx-4'>
            <VerticalProgressBar
              mainclasses='w-full p-6 h-96'
              titleclass='text-sm leading-3 ml-1 font-semibold tracking-wider'
              title='APPOINTMENT DETAILS'
              child={this.appointmentTimeline(data)}
            />
      </div>
      </div>
      )
    }
    
    aptComments(data) {
      return(
        <div className='item-center'>
            <div className='flex flex-row items-center ml-1 pl-2'>
              <div className='font-normal'>
                { data.comments ? data.comments : '-'}
              </div>
              { data?.appointment_request_timelines?.length > 0 &&
                <Popover placement='right' className='cursor-pointer' content={this.appointmentTimelineFormat(data)}>
                <img className='ml-1.5' src={info_icon} style={{width: '14px'}} alt='info' />
              </Popover>}
            </div>
        </div>
    )
    }

    employeeCard = (data, header) => {
      let employeeDetail = { header: header, data: data }
      this.setState({ title: "Employee Details", visible: true, showEmployeeDetailModal: true, employeeDetails:  employeeDetail})
    }

    bookAptBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
              placement='bottom'
              color={'#0D1A35'}
              key='book'
              title={'Book Appointment'}
              align
          >
          <div 
            onClick={() => this.newAppointment(row)}
            className='flex font-medium text-sm leading-4 text-blue-500 cursor-pointer'>
              Book
          </div>
          </Tooltip>
        </span>
      )
    }

    rejectAptBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='reject'
            title='Reject Appointment'
            align
          >
          <div 
            onClick={() => this.rejectPreEmpRequest(row)}
            className='flex font-medium text-sm leading-4 text-red-500 cursor-pointer'>
              Reject
          </div>
          </Tooltip>
        </span>
      )
    }

    rescheduleAptBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='reschedule'
            title='Rescheduled Appointment'
            align
          >
          <div 
            onClick={() => this.rescheduleAppointment(row)}
            className='flex font-medium text-sm leading-4 text-blue-500 cursor-pointer'>
              Reschedule
          </div>
          </Tooltip>
        </span>
      )
    }

    downloadVoucherBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='voucher'
            title={row?.apt_req_status === 'new' ? 'Appointment is not confirmed yet' : 'Download Voucher'}
            align
          >
          <div 
            style={{ cursor: row.appointment_id ? 'pointer' : 'not-allowed' }}>
            <span 
              onClick={row?.apt_req_status === 'new' ? () => {}: () => this.downloadVouher(row)}
              className={` ${row.appointment_id ? '' : 'pointer-events-none'} flex font-medium text-sm leading-4 ${row?.apt_req_status === 'new' ? 'cursor-not-allowed text-gray-275' : 'text-blue-500 cursor-pointer'}`}>
              Download Voucher
            </span>
          </div>
          </Tooltip>
        </span>
      )
    }

    apporoveAptBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='approve'
            title='Approve Appointment'
            align
          >
          <div 
            onClick={() => this.approvePreEmpRequest(row)}
            className='flex font-medium text-sm leading-4 text-blue-500 cursor-pointer'>
              Approve
          </div>
          </Tooltip>
        </span>
      )
    }

    editAptBtn(row){
      return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='edit'
            title='Edit Appointment'
            align
          >
          <div 
            onClick={() => this.editAppointment(row)}
            className='flex font-medium text-sm leading-4 text-blue-500 cursor-pointer'>
              Edit
          </div>
          </Tooltip>
        </span>
      )
    }

    downloadRptBtn(row){
      if(row.reports){
        return(
        <span className='mx-2'>
          <Tooltip 
            placement='bottom'
            color='#0D1A35'
            key='report'
            title='Download Report'
            align
          >
          <div 
            style={{ cursor: row.reports ? 'pointer' : 'not-allowed' }}
            className='flex font-medium text-sm leading-4 text-blue-500 cursor-pointer'>
              <span 
                onClick={() => this.downloadReport(row)}
                className={`${row.reports ? '' : 'pointer-events-none'} font-medium text-sm`}>
                Download Report
              </span>
          </div>
          </Tooltip>
        </span>
      )} else return '-'
    }

    returnTabBtn(tab_header, row) {
      switch(tab_header){
        case 'ready_to_book':
          return this.readToBookBtn(row);
        case 'contacted':
          return this.contactedBtn(row);
        case 'not_reachable':
          return this.notReachableBtn(row);
        case 'scheduled':
          return this.scheduledBtn(row);
        case 'rescheduled':
          return this.rescheduledBtn(row);
        case 'hr_intervention':
          return this.hrInterventionBtn(row);
        case 'awaiting_reports':
          return this.awaitingReportsBtn(row);
        case 'completed':
          return this.completedBtn(row);
        case 'rejected':
          return this.rejectedBtn(row);
      }
    }

    readToBookBtn(data){
      return(
        <div className='flex flex-row'>
          {this.bookAptBtn(data)}
          {this.rejectAptBtn(data)}
        </div>
      )  
    }

    contactedBtn(data){
      return(
        <div className='flex flex-row'>
          {this.bookAptBtn(data)}
        </div>
      )  
    }

    notReachableBtn(data){
      return(
        <div className='flex flex-row'>
          {this.bookAptBtn(data)}
        </div>
      )  
    }

    scheduledBtn(data){
      return(
        <div className='flex flex-row'>
          {this.rescheduleAptBtn(data)}
          {this.downloadVoucherBtn(data)}
        </div>
      )  
    }

    rescheduledBtn(data){
      return(
        <div className='flex flex-row'>
          {this.rescheduleAptBtn(data)}
          {this.downloadVoucherBtn(data)}
        </div>
      )  
    }

    hrInterventionBtn(data){
      let noResponse = data.apt_req_status == 'need_approval' ? true : false
      return(
        <div className='flex flex-row'>
          { noResponse && this.apporoveAptBtn(data)}
          { !noResponse && this.bookAptBtn(data)}
          {/* {this.editAptBtn(data)} */}
          {this.rejectAptBtn(data)}
        </div>
      )  
    }

    awaitingReportsBtn(data){
      return(
        <div className='flex flex-row'>
          {this.downloadVoucherBtn(data)}
        </div>
      )  
    }

    completedBtn(data){
      return(
        <div className='flex flex-row'>
          {this.downloadRptBtn(data)}
        </div>
      )  
    }

    rejectedBtn(data){
      return(
        <div className='flex flex-row'>
          {this.bookAptBtn(data)}
        </div>
      )  
    }

    tableSchema = ({aptData, aptCount, tab_header, index}) => {

      this.action = (row, tabHeader) => {
        if(this.state.role !== 'regional_staff'){
          return(
            <div className='flex flex-row justify-start'>
              {this.returnTabBtn(tabHeader, row)}
            </div>
          )
        }
        return 'NA'
      }

      this.schema = ({ data }) => {
        return(
          <tr key={data.id} className='text-gray-600 text-sm'>
            <td className={`items-center p-4 ${ SALES_ROLE === 'sales' &&  'select-none filter blur-lg pointer-events-none' } `}>
              {this.returnName(data, tab_header)}
            </td>
            { ['scheduled', 'rescheduled', 'awaiting_reports', 'completed'].includes(tab_header) && 
            <td className='px-3 py-5'>{this.appointmentDateTime(data)}</td>}
            <td className={`pl-3 pr-5 py-5 ${ SALES_ROLE === 'sales' &&  'select-none filter blur-lg pointer-events-none'} `}>
              {this.returnEmail(data)}
            </td>
            {/* <td className='ml-2 items-center pl-6'>{this.doctorStatus(data)}</td> */}
             <td className='ml-2 items-center pl-6'>{this.aptComments(data)}</td>
            <td className={`pl-2 py-5 text-center  ${ SALES_ROLE === 'sales' &&  'cursor-not-allowed'} `}><span className={`${SALES_ROLE === 'sales' && 'select-none pointer-events-none '}`}>{this.action(data, tab_header)}</span></td>
          </tr>
        )
      }

      let tableHeight = aptData.length == 10 ? '625px' : '100%'
      let tableHeader = tab_header?.replaceAll('_',' ')
      if(tab_header === 'hr_intervention') tableHeader = 'HR intervention required'
      else if(tab_header === 'awaiting_reports') tableHeader = 'Consultation completed'
      else tableHeader = tab_header?.replaceAll('_',' ')

      return(
        <Spinner loading={this.state.isLoading}>
        <div className='mb-3 pb-3'>
          <div id={index} onClick={() => this.flipTable(index, tab_header)}>
            <DropdownTable 
              status={tableHeader}
              count={aptCount}
              loading={this.state.isLoading}
              showItem={this.state.popTable[index]}
            />
          </div>
          { this.state.popTable[index] &&
          <>
            <AptTable
              loading={this.state.isLoading} 
              tableClasses='alternate_gray200_color' 
              classes='rounded-md'  
              headers={HEADERS[`${tab_header}`]}
              data={aptData} 
              tableschema={this.schema}
              tableHeight={tableHeight}
            />
            { aptCount > 10 && this.pageHandler(aptCount)}
          </>
          }
        </div>
        </Spinner>
      )
    }

    overAll = () => {
      if(this.state.data){
        let AptData = this.state.data;
        return( 
          Object.keys(AptData).map((tab_headers, idx) => {
            let aptDataFormat = { 
                                  aptData: AptData[tab_headers][`${tab_headers}_data`],
                                  aptCount: AptData[tab_headers][`${tab_headers}_count`],
                                  tab_header: tab_headers,
                                  index: idx 
                                }

            return(
                    this.tableSchema(aptDataFormat)
                  )   
      }))
    }
  }

    flipTable = (idx, tab_header) => {
      let popTableLen = this.state.popTable?.length
      let setArrBol = new Array(popTableLen).fill(false)
      setArrBol[idx] = !this.state.popTable[idx]
      this.setState({popTable: setArrBol, 
                     current_page: 1,
                     curpage: 0,
                     tab_status: tab_header
                    })
      this.scrollToMiddle(idx)
      this.getApptData(this.state.currentTab, 1, tab_header)
    }

    scrollToMiddle(idx) {
      let element = document.getElementById(idx)
      const y = element.offsetTop - (window.innerHeight / 2);
    
      setTimeout(function() {
        window.scrollTo(
          {
            top: y,
            left: 0,
            behavior: 'smooth'
          }
        ), 100
      })
    }

    paginateData = (page) => {
      this.onChange(page+1)
      this.setState({ 
        curpage: page,
        isLoading: true
      })
    };

    onChange = (pageNumber) => {
      this.setState({current_page: pageNumber},function(){
        let active_tab = this.state.currentTab
        if (this.state.filtered){
          this.fetchFilteredRecords()
        }
        else {
          this.getPreEmpCheckupData(active_tab)
        }  
      })
    }

    renderOverview(){
      sessionStorage.setItem('defaultSelectedTab', '9')
      this.props.history.push({pathname: '/overview'})
    }

    renderSet(title, desc, img, imgSize = '24px'){
      return(
            <div className='leading-3 text-xs flex flex-row mr-2 my-5 mx-1 overflow-hidden'>
              <span className='mx-2 mt-0.5'>
                <img src={img} alt='email' style={{width: imgSize}} />
              </span>
              <span>
                <div className='text-gray-400 mb-1.5 font-medium tracking-wide'>{title}</div>
                <div className='text-sm leading-3.5 font-bold' style={{color: '#324467'}}>{desc ? desc : 'NA'}</div>
              </span>
            </div>
      )
    }

    renderEmpProfile(data){
      return(
        <div className='text-sm'>
          <div className='font-semibold leading-4 mt-3 ml-2 pl-2' style={{color: '#4D6189'}}>EMPLOYEE DETAILS</div>
          <hr className='mt-4' />
          <div className='m-0.5'>
            {this.renderSet('NAME', data.name ?? '', employee_name)}
            {this.renderSet('PHONE NUMBER', data.mobile_number ?? '', schedule_call)}
            {this.renderSet('EMAIL ID', data.email ?? '', email_pre)}
            {this.renderSet('DOB', data.date_of_birth, dob_icon)}
            {this.renderSet('DATE OF JOINING', data.date_of_joining, doj_calendar)}
            <div className='leading-3 text-xs flex flex-row mr-2 my-3 mx-1 overflow-hidden'>
              <span className='mx-2 mt-0.5'>
                <img src={location} alt='email' style={{width: '24px'}} />
              </span>
              <span>
                <div className='text-gray-400 mb-1.5 font-medium tracking-wide'>ADDRESS</div>
                <div className='text-sm leading-3.5 font-bold' style={{color: '#324467', width: '232px'}}>{data.address ? data.address : 'NA'}</div>
              </span>
            </div>
          </div>
        </div>
      )
    }

    renderApptStatus(data) {
      return(
        <div className='text-sm'>
        <div className='font-semibold leading-4 mt-3 ml-2 pl-2' style={{color: '#4D6189'}}>APPOINTMENT DETAILS</div>
        <hr className='mt-4' />
        <div className='m-0.5'>
          {this.renderSet('PACKAGE DETAILS', data.appointment?.package_names, info_icon)}
          {this.renderSet('APPOINTMENT DATE', data.appointment_date, doj_calendar)}
          {this.renderSet('CREATOR EMAIL ID', data.staff?.email, email_pre)}
          {this.renderSet('CREATED BY', data.staff?.name, created_by)}
        </div>
      </div>
      )
    }

    componentDidMount () {
      this.updateMetric()
      let keyFromOverview = this.state.currentTab
      let tab_status = 'ready_to_book'
      let query = new URLSearchParams(this.props.location.search).get('active_tab')
      let key = ( !this.props.location.state || this.props.location.state.actionKey === null || this.props.location.state.actionKey === undefined || this.props.location.state.actionKey === '' || this.props.location.state.actionKey === " ") ? '1' : this.props.location.state.actionKey
      if(query === 'hr_intervention') {keyFromOverview = 'hr_intervention'; tab_status = 'hr_intervention'; this.props.history.push({ pathname: '/pre-employee-checkup', search: ''}) }
      if(key === '2'){ tab_status = keyFromOverview = "hr_intervention", this.props.location.state.actionKey = '', this.setState({tab_key: 4, current: 1, curpage: 0}) }
      if(key === '3'){ tab_status = keyFromOverview = "ready_to_book", this.props.location.state.actionKey = '', this.setState({tab_key: 1, current: 2, curpage: 0})}
      this.getApptData(keyFromOverview, 1, tab_status)
      this.setflipCount()
      this.updateStep(keyFromOverview)
    }

    updateMetric (val = '') {
      let options = val !== '' ? { params: { term: val } } : {}
      if(this.state.search_text !== ''){
        options = { params: { term: this.state.search_text} }
      }

      employeeDataApi.fetch_pre_emp_total_records({...options, companyId: this.state.companyId, type: 'PreEmployeeAppointment'},
        (res) => {
          this.setState({total_records: res.data.appointment_requests_counts})
        },
        (err) => {
          handleAppError(err)
        })
    }

    getApptData (tabKey = 'all', tab_page = null, tab_status = null) {
      this.setState({isLoading: true})
      let page = tab_page ?? this.state.current_page
      let status_tab = tab_status ?? this.state.tab_status
      let options = { params: { active_tab: tabKey, page: page, status_tab: status_tab, company_id: this.state.companyId, type: 'PreEmployeeAppointment' } }
      
      if(this.state.search_text !== ""){
        options = { params: { active_tab: tabKey, page: page, term: this.state.search_text, status_tab: status_tab, company_id: this.state.companyId, type: 'PreEmployeeAppointment' } }
      }

      employeeDataApi.fetch_pre_emp_records(options,
        (res) => {
          this.setState({ data: res.data['appointment_requests'],
                          show_filters: false, 
                          showAppointmentModal: false,
                          showAddPreEmployeeModal: false,
                          showBulkPreEmployeeModal: false,
                          showEmployeeDetailModal: false,
                          showApproveRequestModal: false,
                          showRejectRequestModalL: false,
                          showRescheduledAptModal: false,
                          isLoading: false })
          this.updateMetric()
        },
        (err) => {
          handleAppError(err)
        })
    }

    setflipCount = () => {
      let AptData = this.state.data;

      let len = Object.keys(AptData).length
      let setArr = new Array(len).fill(false)
      setArr[0] = true;
      this.setState({popTable: setArr})
    } 

    searchCustomer(value){
      let active_tab = this.state.currentTab;
      let filters = { selected_appointment_status: [], selected_doctor_status: [], selected_reports_digitized: false,selected_company_staff: [] }
      this.setState({search_text: value, filtered: false, show_filters: false, showAppointmentModal: false,showAddPreEmployeeModal: false,showBulkPreEmployeeModal: false, showAddPreEmployeeModal: false, selected_filters: filters, current_page: 1, curpage: 0}, function(){
        this.getPreEmpCheckupData(active_tab)
      })
      this.updateMetric(value)
    }

    getPreEmpCheckupData(tabKey) {
      this.getApptData(tabKey)
    }

    updateStep = (tabKey) => {
      const ids = tabbarList.ids.indexOf(tabKey)
      this.setState({show_filters: false, showAppointmentModal: false,showAddPreEmployeeModal: false,showBulkPreEmployeeModal: false, tab_key: ids, current_page: 1, current: ids, curpage: 0, currentTab: tabKey}, function(){
        this.switchTabs(tabKey)
      })
      this.setflipCount()     
    }

    switchTabs = (tabKey) => {
      let tab_status = tabKey
      if(tabKey == 'atmpt_to_book') tab_status = 'contacted'
      if(tabKey == 'all') tab_status = 'ready_to_book'
      this.getApptData(tabKey, 1 , tab_status)
      this.setState({tab_status: tab_status})
    }

    fetchFilteredRecords(){
      let that = this
      let request_body = this.generateFilters()
      if (request_body["filtered"]) {
        this.setState({isLoading: true, filtered: true}, function(){
          let url = window.API_URL + 'corporate/appointment-requests/search?' +  'page=' + this.state.current_page + '&company_id=' + this.state.companyId
          window.axios.post(url, request_body)
          .then(function (response) {
            that.setState({data: response.data['appointment_requests'], total: response.data['meta']['total'], show_filters: false, showAppointmentModal: false,showAddPreEmployeeModal: false,showBulkPreEmployeeModal: false,isLoading: false})
          })
          .catch(function (error) {
            that.setState({isLoading: false})
          })
        })
      }  
      else {
        this.setState({filtered: false}, function(){
          this.getPreEmpCheckupData('all')
        })
      } 
    }

    generateFilters(){
      let query = {}
      let filtered = false
      if (this.state.selected_filters.selected_appointment_status.length > 0){
        query["appointment_status"] = this.state.selected_filters.selected_appointment_status
        filtered = true
      }
      if (this.state.selected_filters.selected_doctor_status.length > 0){
        query["doctor_status"] = this.state.selected_filters.selected_doctor_status
        filtered = true
      }
      if (this.state.selected_filters.selected_reports_digitized){
        query["reports_digitized"] = this.state.selected_filters.selected_reports_digitized
        filtered = true
      }
      if (this.state.selected_filters.selected_company_staff.length > 0){
        query["company_staff"] = this.state.selected_filters.selected_company_staff
        filtered = true
      }
      query["filtered"] = filtered    
      return query
    }

    approvePreEmpRequest = (data) => {
      let employeeDetail = { header: 'approveRequest', data: data }
      this.setState({title: "Approve Request", visible: true, showApproveRequestModal: true, employeeDetails: employeeDetail})
    }

    approveRequest = () =>  {
      let row = this.state.employeeDetails?.data
        let that = this
        window.axios.patch(window.API_URL + 'corporate/appointment-requests/'+row.id+'/approve')
        .then(function (response) {
            successOrFailureToaster({message: 'Appointment approved successfully', type: 'success'})
            that.setState({tab_key: 0, visible: false, showApproveRequestModal: false})
            that.updateStep('hr_intervention')
        })
        .catch(function (error) {
            successOrFailureToaster({message: error.response.data.msg, type: 'fail'})
            that.setState({tab_key: 0, visible: false, showApproveRequestModal: false})
        })
    }

    rejectPreEmpRequest = (data) => {
      let employeeDetail = { header: 'rejectRequest', data: data }
      this.setState({title: "Approve Request", visible: true, showRejectRequestModal: true, employeeDetails: employeeDetail})
    }

    rejectRequest = () =>  {
      let row = this.state.employeeDetails?.data
        let that = this
        window.axios.patch(window.API_URL + 'corporate/appointment-requests/'+row.id+'/reject')
        .then(function (response) {
            successOrFailureToaster({message: 'Appointment moved to rejected tab', type: 'success'})
            that.setState({tab_key: 0, visible: false, showRejectRequestModal: false})
            that.updateStep('ready_to_book')
        })
        .catch(function (error) {
          successOrFailureToaster({message: 'Something went wrong!', type: 'fail'})
          that.setState({tab_key: 0, visible: false, showRejectRequestModal: false})
        })
    }

    uploadCsvData =  () => {
      this.setState({showCsvLoader: true, csvDownloadState: false})
      let options = { params: {company_id: this.state.companyId, type: 'PreEmployeeAppointment'} }
      employeeDataApi.upload_pre_emp_csv(options, 
        (_) => {
          let intervalId = setTimeout(() => this.downloadCsvData(), 0)
          let abortId =  setTimeout(this.abortPolling, 1000 * 10)
          let proValue = this.state.progressValue + 5
          this.setState({intervalId: intervalId, abortId: abortId, progressValue: proValue})
        }, 
      (_) => {  
        successOrFailureToaster({message: 'Something went wrong!', type: 'fail'}) 
        this.setState({showCsvLoader: false, showDownloadModel: false})
      })
    }
  
  
    downloadCsvData = () =>{
      let options = {type: 'PreEmployeeAppointment'}
      try {
        employeeDataApi.download_pre_emp_csv(options, 
          (res) => {
            clearTimeout(this.state.intervalId)
            clearTimeout(this.state.abortId)
            this.setState({showCsvLoader: false, intervalId: false, abortId: false})
            setTimeout(() => { this.setState({progressValue: 98})}, 500);
            setTimeout(() => { this.setState({progressValue: 100})}, 1000);
            setTimeout(() => {this.setState({csvDownloadState: true, progressValue: 0})}, 1500);
            const link = document.createElement('a');
            link.href = res.data?.file?.url;
            link.setAttribute('download','pre_employment_csv'+".csv");
            document.body.appendChild(link);
            link.click();
            successOrFailureToaster({ message: 'Data downloaded successfully' })

          }, 
        (e)=> { 
          let intervalId =  setTimeout(() => this.downloadCsvData(), 1000);
          if(this.state.progressValue < 96 ){
            this.setState(prevState => {
              if (prevState.progressValue < 96) {
                return { progressValue: prevState.progressValue + 5 };
              } else {
                return { progressValue: prevState.progressValue };
              }
            });
            
            this.setState({intervalId: intervalId})
          }
        })
      } catch (error) {
          clearTimeout(this.state.intervalId)
          clearTimeout(this.state.abortId)
          successOrFailureToaster({message: 'Something went wrong!', type: 'fail'}) 
      }
    }
  
    abortPolling = (type) => {
      clearTimeout(this.state.intervalId)
      clearTimeout(this.state.abortId)
      if(type == 'cancel') successOrFailureToaster({ message: 'downloading cancelled!', type: 'fail' })
      else successOrFailureToaster({ message: 'The download is taking longer than expected. The processed file will be sent to your email shortly.', type: 'custom' })
      this.setState({showCsvLoader: false, intervalId: false, abortId: false, 
                     progressValue: 0,  csvDownloadState: false, showDownloadModel: false})
    }

    downloadVouher = (row) => {
      // let that = this
      let name = row.name
      document.body.style.cursor = 'wait';
      window.axios({
          url: window.API_URL + `corporate/appointment-requests/download_voucher?id=${row.id}&company_id=${this.state.companyId}`,
          method: 'GET',
          headers: {'Accept': 'application/zip',
          'Content-Type': 'application/zip'},
          responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name+".pdf"); //or any other extension
            document.body.appendChild(link);
            link.click();
            setTimeout(() => {
              document.body.style.cursor = 'auto';
            }, 1500);
      })
      .catch((error) => {
        successOrFailureToaster({message: 'Something went wrong! Try again', type: 'fail'})
        setTimeout(() => {
          document.body.style.cursor = 'auto';
        }, 1500);
      });
    }

    downloadReport = (row) => {
      // let that = this
      document.body.style.cursor = 'wait';
      let name = row.name
      window.axios({
          url: window.API_URL + 'corporate/appointment-requests/'+row.id+'/download_report?company_id='+this.state.companyId,
          method: 'GET',
          headers: {'Accept': 'application/zip',
          'Content-Type': 'application/zip'},
          responseType: 'blob', // important
      }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name+".zip"); //or any other extension
            document.body.appendChild(link);
            link.click();
            document.body.style.cursor = 'auto';
      })
      .catch((error) => {
        successOrFailureToaster({message: error?.response?.data?.msg || 'Something went wrong! Try again', type: 'fail'})
        document.body.style.cursor = 'auto';
      });
    }

    downloadFile = (row , fileId) => {
        // let that = this
        window.axios({
            url: window.API_URL + 'corporate/appointment-requests/'+row.id+'/reports/'+fileId+'?company_id='+this.state.companyId,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
    }
    
    onFormSubmitSuccess = (e) => {
      let tabKey = 'ready_to_book'
      let keyValue = 1
      let that = this
      if(that.state.role === 'regional_staff'){ tabKey = "ready_to_book" , keyValue = 1}
      this.setState({
      visible: false,
      showAddPreEmployeeModal: false,
      showBulkPreEmployeeModal: false,
      tab_key: keyValue,
      });
      message.success(e.data.msg);
      this.updateStep(tabKey)
    }

    onFormSubmitFail = (e) => {
      let tabKey = 'ready_to_book'
      let keyValue = 1
      let that = this
      if(that.state.role === 'regional_staff'){ tabKey = "ready_to_book" , keyValue = 1}
      this.setState({
      tab_key: keyValue,
      });
      message.error(e.response.data.msg);
    }

    handleCancel = (e) => {
        this.setState({
        visible: false,
        showAppointmentModal: false,
        showAddPreEmployeeModal: false,
        showBulkPreEmployeeModal: false,
        title: ''
        });
    }

    handleClose = (e) => {
    let tabKey = this.state.currentTab
    let keyValue = this.state.current
    let that = this
    if(that.state.tab_key === 1){ tabKey = "ready_to_book" , keyValue = 1}
      this.setState({
      visible: false,
      showAppointmentModal: false,
      showAddPreEmployeeModal: false,
      showBulkPreEmployeeModal: false,
      tab_key: keyValue,
      title: ''
      });
      this.updateStep(tabKey)     
    }


    enableFilters = () => {
      this.setState({show_filters: true})
    }

    cancelModal(e){
      this.setState({show_filters: false})
      this.setState({showAppointmentModal: false})
      this.setState({showAddPreEmployeeModal: false})
      this.setState({showBulkPreEmployeeModal: false})
      this.setState({showEmployeeDetailModal: false, 
                     showApproveRequestModal: false, 
                     showRejectRequestModal: false,
                     showRescheduledAptModal: false})
    }

    updateFilters(obj){
      this.setState({selected_filters: obj, current_page: 1},function(){
        this.fetchFilteredRecords()
      })  
    }

    renderFiltersCount(){
      let count = 0
      count = this.state.selected_filters.selected_appointment_status.length > 0 ? count + 1 : count
      count = this.state.selected_filters.selected_doctor_status.length > 0 ? count + 1 : count
      count = this.state.selected_filters.selected_reports_digitized ? count + 1 : count
      count = this.state.selected_filters.selected_company_staff.length > 0 ? count + 1 : count
      return count
    }

    renderFilters(){
      if (this.state.show_filters && this.state.tab_key !== 1) {
        return(<PreEmpFilters visible={this.state.show_filters} filters={this.state.filters} selected_filters={this.state.selected_filters} updateFilters={this.updateFilters.bind(this)} closeModal={this.cancelModal.bind(this)} />)
      }
      else {
        return(<div/>)
      }
    }

    updateGender = (gender) => {
      let updated_customer = update(this.state.new_record, {gender: {$set: gender}})
      this.setState({new_record: updated_customer})
    }

    updateMobileNumber = (mobileNumber) => {
      let updated_customer = update(this.state.new_record, {mobile_number: {$set: mobileNumber}})
      this.setState({new_record: updated_customer})
    }

    updateEmail = (email) => {
      let updated_customer = update(this.state.new_record, {email: {$set: email}})
      this.setState({new_record: updated_customer})
    }

    updateDateOfBirth = (dob) => {
      let updated_customer = update(this.state.new_record, {birth_date: {$set: dob}})
      this.setState({new_record: updated_customer})
    }

    updateDateOfJoining = (doj) => {
      let updated_customer = update(this.state.new_record, {joining_date: {$set: doj}})
      this.setState({new_record: updated_customer})
    }

    csvDownloadModal = () => {
      this.setState({title: "csv download", visible: true, showDownloadModel: true, buttonTag: 'download csv'})
      this.uploadCsvData()
    }
    
    newAppointment = (row) => {
      this.setState({title: "Book appointment", visible: true, new_record: row,showAppointmentModal: true, buttonTag: 'Create appointment', showEmployeeDetailModal: false, step: 1})
    }

    addPreEmp = () => {
      this.setState({title: "Add Pre Employee", visible: true, showAddPreEmployeeModal: true})
    }

    addBulkEmp = () => {
      this.setState({title: "Bulk Upload", visible: true, showBulkPreEmployeeModal: true})
    }

    rescheduleAppointment = (row) => {
      this.setState({title: "Reschedule appointment", visible: true, new_record: row, showRescheduledAptModal: true, buttonTag: 'Reschedule appointment', showEmployeeDetailModal: false})
    }

    editAppointment = (row) => {
      this.setState({title: "Edit appointment", visible: true, new_record: row, showAppointmentModal: true, buttonTag: 'Save appointment', showEmployeeDetailModal: false})
    }

    getStepComponent = () => {
      return(this.overAll())
    }

    postAddAppointment = (val) => {
      let tabKey = 'ready_to_book'
      let keyValue = 1
      let tabStatus = 'ready_to_book'
      let that = this
      if(val === 'reschedule' || val === 'book') { tabKey = 'scheduled', tabStatus =  'scheduled'}
      if(that.state.tab_key === 1){ tabKey = "ready_to_book" , keyValue = 1}
      that.setState({ visible: false, showAppointmentModal: false, showRescheduledAptModal: false, tab_key: keyValue, status_tab: tabKey });
      that.getApptData(tabKey, 1, tabStatus)
      that.updateStep(tabKey)
    }

    renderCsvLoader(){
      return(
      <button
        onClick={this.csvDownloadModal}
        className={`flex flex-row rounded-md leading-5 py-3 text-base font-semibold text-blue-600 focus:outline-none px-2 ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
        disabled={SALES_ROLE === "sales"}
      >
        {this.state.showCsvLoader === true ? <SpinnerLinear classes='-mt-1.5 mr-1' />: <img src={download} alt='icon' className='mr-2' style={{width: '20px'}}/> }
        Download CSV
      </button>)
    }

    exportToCsv = (e) => {
      // let that = this
      let today = new Date()
      let date = 'PreEmpCheckup' + '_' + today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      this.setState({showCsvLoader: true})
      window.axios.post(window.API_URL + 'corporate/appointment-requests/new_download_csv.csv', {company_id: this.state.companyId, type: 'PreEmployeeAppointment'}, {responseType: 'blob'}
      ).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', date+".csv"); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.setState({
              showCsvLoader: false
            })
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          showCsvLoader: false
        })
      });
    }

    BookAppointmentHandler = (mobileNumber, packageID, packageName, packageType) => {
      this.setState({ selectedEmpMobileNumber: mobileNumber, selectedPackageID: packageID, selectedPackageName: packageName, selectedPackageType: packageType })
      this.setState({ step:2 })
    }

    chooseAddressHandler = (value, text) => {
      switch(text){
        case 'new-address':
          this.setState({ newAddress: value, latitude: value.latitude, longitude: value.longitude, isNewAddress: true});
          this.setState({ step: 3 })
          break;
        case 'existing-address':
          this.setState({ existingAddress: value, latitude: value.latitude, longitude: value.longitude, isNewAddress: false, line1: null });
          this.setState({ step: 4 })
      }
    }

    failureHandler = () => {
      this.setState({ showAppointmentModal: false, step: 0 })
    }

    addAddressHandler = () =>{
      this.setState({ step: 4 })
    }
  
    addLine1 = (value) =>{
      this.setState({line1: value})
    }

    createHandler = (provider, date, time, uniqueID) => {
      this.setState({ selectedDate: date, selectedProvider: provider, selectedTime: time, uniqueID: uniqueID })
      this.setState({ step: 5 })
    }

    renderAddAppointmentModel = () => {
      let backText = this.getBackText()
      return(
        <CustomAppointmentDrawer
          title={ this.getTitle() }
          handleBack={ () => this.handleBack(backText) }
          handleCancel={ () => this.handleCancel() }
          body={ this.getBody() }
        />)
    }

    getTitle = () => {
      let step = this.state.step;
      switch(step){
        case 1:
          return 'Book appointment';
          break;
        case 2:
          return 'Choose address';
          break;
        case 3: 
          return 'Save new address';
          break;
        case 4:
          return 'Choose provider';
          break;
        case 5:
          return 'Appointment booked'
      }
    }
  
    getBody = () =>{
      let step = this.state.step;
      switch(step){      
        case 1:
          return <PreEmpBookAppointmentModal
            visible={this.state.showAppointmentModal}
            appointmentRequestId={this.state.new_record.id}
            employeeID={this.state.new_record.customer_id}
            employeeEmail={this.state.new_record.email}
            employeeName={this.state.new_record.name}
            employeeMobileNumber={this.state.new_record.mobile_number}
            employeeGender={this.state.new_record.gender}
            employeeDOB={this.state.new_record.birth_date}
            employeeDOJ={this.state.new_record.joining_date}
            BookAppointmentHandler={this.BookAppointmentHandler}
            benefitType={'pre_employment'}
          />;
          break;
        case 2:
          return <ChooseAddressModal 
            employeeID={this.state.new_record.customer_id}
            chooseAddressHandler={this.chooseAddressHandler}
          />
          break;
        case 3:
          return <AddAddressModal
            newAddress={this.state.newAddress}
            employeeID={this.state.new_record.customer_id}
            changeHandler={()=>this.handleBack('add-address')}
            addAddressHandler={this.addAddressHandler}
            addLine1={this.addLine1}
          />;
          break;
        case 4:
          return <PreEmpChooseProviderModal
            packageID={this.state.selectedPackageID}
            packageType={this.state.selectedPackageType}
            employeeID={this.state.new_record.customer_id}
            employeeName={this.state.new_record.name}
            changeHandler={()=>this.handleBack('choose-provider')}
            createHandler={this.createHandler}
            address={this.state.isNewAddress ? this.state.newAddress : this.state.existingAddress}
            line1={this.state.line1}
            mobileNumber={this.state.selectedEmpMobileNumber}
            failureHandler={this.failureHandler}
            appointmentRequestId={this.state.new_record.id}
            benefitType={'pre_employment'}
          />;
          break;
        case 5:
          return <AppointmentBookedModal
            packageName={this.state.selectedPackageName}
            provider={this.state.selectedProvider}
            employeeName={this.state.new_record.name}
            date={this.state.selectedDate}
            time={this.state.selectedTime}
            uniqueID={this.state.uniqueID}
            handleClose={this.handleClose}
            failureHandler={this.failureHandler}
          />;
      }
    }

    getBackText = () => {
      let step = this.state.step;
      switch(step){
        case 1:
          return 'book-appointment';
          break;
        case 2:
          return 'choose-address';
          break;
        case 3: 
          return 'add-address';
          break;
        case 4:
          return 'choose-provider';
      }
    }
  
    handleBack = (text) =>{
      switch(text){
        case 'book-appointment':
          this.setState({showAppointmentModal: false, step: 0});
          break;
        case 'choose-address':
          this.setState({ step: 1 })
          break;
        case 'add-address':
          this.setState({ step: 2 })
          break;
        case 'choose-provider':
          this.setState({ step: 2 })
          break;
        default:
          this.setState({showAppointmentModal: false, step: 0});
      }
    }

    renderModal(){
      if (this.state.show_filters && this.state.tab_key !== 1) {
        return(<PreEmpFilters visible={this.state.show_filters} filters={this.state.filters} selected_filters={this.state.selected_filters} updateFilters={this.updateFilters.bind(this)} closeModal={this.cancelModal.bind(this)} />)
      } else if (this.state.showAppointmentModal) {
        return(this.renderAddAppointmentModel())
      } else if (this.state.showAddPreEmployeeModal){
        return(
          <CustomDrawer
          title='Add pre employee'
          subHeaderStyle={{
            fontSize: '18px',
            fontWeight: '600',
            display: 'flex',
            paddingTop: '6px',
            justifyContent: 'space-between',
          }}
          visible={this.state.visible}
          width='38%'
          headerStyle={{
            backgroundColor: 'white',
            padding: '0 24px',
          }}
          close={this.handleClose}
          body={
            <AddSingle 
              sponsorId ={this.state.sponsorId}
              closeModal={this.cancelModal.bind(this)}
              onFormSubmitSuccess={this.onFormSubmitSuccess}
              onFormSubmitFail={this.onFormSubmitFail}
              style={{width: '40%'}}
            />
          }
      
          />
          )
      } else if (this.state.showBulkPreEmployeeModal) {
          return(
            this.props.history.push('/pre-employee-checkup/bulk-upload')            
          )
      }
        else if (this.state.showEmployeeDetailModal) {
          return (
                  <Drawer
                  visible={this.state.visible}
                  width='100%'
                  className='help-drawer-xs'
                  closable={false}
                  >
                    <EmployeeDetailsCard 
                      currTab={this.state.employeeDetails.header}
                      aptData={this.state.employeeDetails.data}
                      onClose={this.cancelModal.bind(this)}
                      approveRequest={this.approveRequest}
                      rejectRequest={this.rejectRequest}
                      bookRequest={this.newAppointment}
                      downloadReport={this.downloadReport}
                      downloadVoucher={this.downloadVouher}
                      rescheduleRequest={this.rescheduleAppointment}
                      editRequest={this.editAppointment}
                    />
                    </Drawer>
          )
        }
        else if(this.state.showApproveRequestModal){
          return(
            <ConfirmModal
              visible={this.state.visible}
              heading='Do you want to approve appointment?'
              handler={this.approveRequest}
              liner='Once you approve the pre-employment appointment, the appointment will move to the ready to book tab'
              closeHandler={this.cancelModal.bind(this)}
              confirmIcon={green_tick_mark}
            />
          )
        }
        else if(this.state.showRejectRequestModal){
          return(
            <ConfirmModal
              visible={this.state.visible}
              heading='Do you want to reject appointment?'
              handler={this.rejectRequest}
              liner='Employee will not able to take pre-employment checkups and the appointment will move to the rejected tab'
              closeHandler={this.cancelModal.bind(this)}
              confirmIcon={cross_mark}
            />
          )
        }
        else if(this.state.showRescheduledAptModal) {
          return(
            <CustomDrawer
            visible={this.state.visible}
            width='38%'
            onCancel={this.handleCancel}
            close={this.handleClose}
            title={this.state.title}
            subHeaderStyle={{
              fontSize: '18px',
              fontWeight: '600',
              display: 'flex',
              paddingTop: '6px',
              justifyContent: 'space-between',
            }}
            headerStyle={{
              backgroundColor: 'white',
              padding: '0 24px',
            }}
            footer={null}
            body={<RescheduledAppointmentDrawer 
                    visible={this.state.showRescheduledAptModal}
                    appointment={this.state.new_record?.appointment}
                    appointmentRequestId={this.state.new_record.id}
                    sponsor={this.state.new_record.sponsor}
                    postUpdate={this.postAddAppointment}
                    closeModal={this.cancelModal.bind(this)}
                />}
  
          />
          )
        }
        else if(this.state.showDownloadModel){
          let mState = this.state.csvDownloadState
          return(
              <DownloadCircularProgressModel
                visible={true}
                title={<p className='text-xl leading-5 font-semibold text-gray-700'>{ mState ? "Download completed" :   "Analyzing data..." }</p>}
                description={<p className='text-base leading-5 mt-8 text-gray-600'>
                { mState  ?  
                  'File is saved on your computer, and a copy is sent to your registered email address.' 
                  : 
                  ( this.state.progressValue <  95
                    ?   
                      <>                          
                        <p className='-mt-3'>Your download is getting ready, please wait for download to start.</p>
                        <p className='mt-3'>This may take few minutes for larger data.</p>
                      </>
                    : 
                      <>
                        <p className='-mt-3'> Your download may take few more minutes owing to large amount of data.</p>
                        <p className='mt-2'>You may continue browsing, to receive a copy to your registered email address when the file is ready.</p>
                      </>
                  )
                }
                </p>
              }
                btnText={mState ? 'Done' :'Cancel'}
                btnClasses= {mState ? 'text-white bg-blue-600' : 'text-blue-600 bg-white border border-gray-200'}
                icon={mState ? greenTickThick : ''}
                width={mState ? 596 : 596}
                height={mState ? 338 : 473}
                dashArray={[this.state.progressValue , 100]}
                onCancel={mState ? () => {this.setState({showDownloadModel: false})} : () => {this.setState({showDownloadModel: false})}}
                handler={mState ? () => {this.setState({showDownloadModel: false, csvDownloadState: false})} : () => {this.setState({showDownloadModel: false})}}
            />
          )
        }
       else {
        return(<div/>)
      }
    }

    render () {
      let tagBar = this.state.total_records ? Object.values(this.state.total_records) : '';
      const size = this.state.size;
      let key = ( !this.props.location.state || this.props.location.state.actionKey === '' ) ? this.state.tab_key : this.props.location.state.actionKey
      return (
          <Spinner loading={this.state.isLoading}>
            <div className='scroll-smooth'>
                <div className='flex justify-between'>
                  <Heading 
                    mainHeading='Pre employment checkups' 
                    mainClasses='text-gray-900 text-xl font-semibold leading-5' 
                    subHeading='Detailed information on pre-employment examinations'
                    subClasses='mt-2'
                  />
                  <div className='flex justify-around'>
                    <div className='mr-3'>
                      {this.renderCsvLoader()}
                    </div>
                    <button
                      type='submit'
                      onClick={() => this.addPreEmp()}
                      disabled={SALES_ROLE === "sales"}
                      className={`rounded-md leading-5 border-2 py-3 bg-white text-base font-semibold text-blue-600 focus:outline-none px-6 mr-3 flex flex-row ${SALES_ROLE === 'sales' ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                      <img src={single_add_icon} width='20px' />
                      <span className='mx-1'>Add single</span>
                    </button>
                    <button
                      type='submit'
                      onClick={() => this.addBulkEmp()}
                      className='rounded-md leading-5 border-none py-3 bg-blue-600 text-base font-semibold text-white focus:outline-none px-6 flex flex-row'
                    >
                      <img src={bulk_add_icon} width='20px' />
                      <span className='mx-1'>Add bulk</span>
                    </button>
                  </div>
                </div>
                <SearchBar 
                  classes='mb-4 h-12 mt-8 mb-6'
                  placeholder='Search employee by name, email id and mobile number'
                  inputClasses='px-3 rounded-md pt-4 pb-3 pl-10 text-base'
                  handler={value => {this.searchCustomer(value)}}
                  CloseIconHandler={() =>  this.searchCustomer('')}
                />
                <div className='flex whitespace-nowrap overflow-auto scroll-smooth no-scrollbar'>
                  <Tabbar 
                    classes="mt-3"
                    list={tabbarList.list}
                    total={tagBar} 
                    ids={tabbarList.ids} 
                    newPageId={tabbarList.ids[this.state.current]}
                    changeHandler={this.updateStep}
                    alertIcon='HR intervention required'
                    tabItemClassName='w-auto whitespace-nowrap'
                  />
                </div>
               
                <div className='mt-6 scroll-smooth'>
                  {this.getStepComponent()}
                </div>
                {this.renderModal()} 
            </div>
            </Spinner>
        )
    }
}
export default PreEmpCheckup;